<template>
    <div
        class="z-999 sm:z-40  bg-white absolute w-full h-screen mx-auto sm:pl-16 lg:px-20 right-0 opacity-95"
    >
        <router-link to="/" class="right-0 absolute p-2">
            <img
                src="images/close.png"
                class="bg-el-right p-2 h-10 w-10 rounded-full"
            />
        </router-link>
        <div class="mt-10">
            <div class="grid grid-cols-1">
                <div class="p-4 pl-10 lg:pl-32 lg:p-32 py-10 text-left">
                    <h1
                        class="text-base text-color-1 font-montserrat font-semibold mb-6"
                    >
                        La technologie
                    </h1>
                    <p
                        class="leading-relaxed font-montserrat text-color-5
                    text-left text-sm whitespace-normal align-middle font-light mb-4"
                    >
                        Cette partie vous renseigne sur la méthodologie de génération des cadastres,
                        la méthodologie d’accès aux données pour l’utilisateur et le type d’informations que vous pourrez
                        trouver sur le cadastre solaire.
                    </p>
                    <p
                        class="leading-relaxed font-montserrat text-color-5
                    text-left text-sm whitespace-normal align-middle font-light mb-4"
                    >
                        Les données sont l'élément le plus important dans un projet SIG. En effet,
                        dans le cadre ce projet, les données utilisées ont été extraites des images aériennes de chaque ville,
                        en utilisant des techniques de restitution photogrammétrique obtenues auprès des agences urbaines du royaume.
                    </p>
                    <p
                        class="leading-relaxed font-montserrat text-color-5
                    text-left text-sm whitespace-normal align-middle font-light mb-4"
                    >
                        Ces données sont vectorisées et enregistrées dans un fichier CAO et par la suite intégrées dans une base de données SIG.
                        D’autre part, l'attribution d’un système de coordonnées (Conformal Lambert Zone 1) est nécessaire pour une meilleure manipulation de données,
                        caractérisées par une précision élevée et contenant également un attribut altimétrique de toutes les structures numérisées.
                    </p>
                    <p
                        class="leading-relaxed font-montserrat text-color-5
                    text-left text-sm whitespace-normal align-middle font-light mb-4"
                    >
                        Pour évaluer le potentiel solaire photovoltaïque sur les toits dans les zones urbaines,
                        nous utilisons une approche hiérarchique qui est largement utilisée dans la littérature,
                        et comprend trois étapes :
                    </p>

                    <p
                        class="leading-relaxed font-montserrat text-color-5
                    text-left text-sm whitespace-normal align-middle font-light mb-4"
                    >
                        - La production d'un modèle 3D de bâtiments à partir de données extraites de la restitution
                        photogrammétrique. Cette étape comprend la création du modèle d'élévation numérique à partir
                        d’un nuage de points d’altitude couvrant la zone étudiée.
                    </p>
                    <p
                        class="leading-relaxed font-montserrat text-color-5
                    text-left text-sm whitespace-normal align-middle font-light mb-4"
                    >
                        - La génération d’un rayonnement solaire à l'aide des outils d’analyses solaires développées,
                        tout en tenant compte des orientations et inclinaisons des toitures ainsi que des ombrages
                        générés par les autres bâtiments en se basant sur un modèle 3D.
                    </p>

                    <p
                        class="leading-relaxed font-montserrat text-color-5
                    text-left text-sm whitespace-normal align-middle font-light mb-4"
                    >
                        - Le calcul de la puissance photovoltaïque installable, le potentiel de production photovoltaïque
                        et le coût d'investissement au niveau de la toiture adéquate sur la zone étudiée en fonction
                        du rayonnement solaire déjà calculé et des paramètres techniques.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {

    }
};
</script>
